export default __webpack_public_path__ + "static/media/PM8000.cd0c3887.png";